import { JSX } from 'react';

const IconStepsArrowRight = (): JSX.Element => {
  return (
    <path
      d="M22.1367 56.0221C21.7824 55.6594 21.584 55.1724 21.584 54.6653C21.584 54.1581 21.7824 53.6712 22.1367 53.3084L41.9333 32.9999L22.1367 12.6956C21.7824 12.3328 21.584 11.8458 21.584 11.3387C21.584 10.8316 21.7824 10.3446 22.1367 9.98182C22.3089 9.80492 22.5149 9.66432 22.7423 9.56832C22.9698 9.47232 23.2142 9.42286 23.4611 9.42286C23.708 9.42286 23.9524 9.47232 24.1798 9.56832C24.4073 9.66432 24.6132 9.80492 24.7855 9.98182L45.8373 31.5821C46.2071 31.9615 46.414 32.4702 46.414 32.9999C46.414 33.5297 46.2071 34.0384 45.8373 34.4178L24.7855 56.0181C24.6132 56.195 24.4073 56.3356 24.1798 56.4316C23.9524 56.5276 23.708 56.577 23.4611 56.577C23.2142 56.577 22.9698 56.5276 22.7423 56.4316C22.5149 56.3356 22.3089 56.195 22.1367 56.0181V56.0221Z"
      fill="currentColor"
    />
  );
};

export default IconStepsArrowRight;
